import React, { ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ButtonStandard.module.css';

export enum ButtonStandardType {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  TextPrimary = 'textPrimary',
  TextSecondary = 'textSecondary',
  TextDanger = 'textDanger'
}

export enum ButtonStandardHoverEffectType {
  None = 'none',
  HalfTransparent = 'halfTransparent'
}

export type ButtonStandardProps = Omit<
  ComponentProps<'button'>,
  'type' | 'ref'
> & {
  type?: ButtonStandardType;
  hoverEffectType?: ButtonStandardHoverEffectType;
};

// eslint-disable-next-line react/no-multi-comp
export const ButtonStandard = React.memo(
  React.forwardRef<HTMLButtonElement, ButtonStandardProps>((props, ref) => {
    const {
      type = ButtonStandardType.Secondary,
      hoverEffectType = ButtonStandardHoverEffectType.None,
      className,
      children,
      ...remainingProps
    } = prepareProps({ props });

    return (
      <button
        ref={ref}
        type="button"
        {...remainingProps}
        className={classes(
          className,
          styles.button,
          buttonTypeToClassName[type],
          hoverEffectTypeToClassName[hoverEffectType]
        )}
      >
        {children}
      </button>
    );
  })
);

const buttonTypeToClassName: Record<ButtonStandardType, string | null> = {
  [ButtonStandardType.Primary]: styles.buttonPrimary,
  [ButtonStandardType.Secondary]: styles.buttonSecondary,
  [ButtonStandardType.Danger]: styles.buttonDanger,
  [ButtonStandardType.TextPrimary]: styles.buttonTextPrimary,
  [ButtonStandardType.TextSecondary]: styles.buttonTextSecondary,
  [ButtonStandardType.TextDanger]: styles.buttonTextDanger
};

const hoverEffectTypeToClassName: Record<
  ButtonStandardHoverEffectType,
  string | null
> = {
  none: null,
  halfTransparent: styles.hoverEffectHalfTransparent
};
